__turbopack_context__.v({
  "link": "index-module__lVVYbq__link",
});
